import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { ListingDescriptionSchema } from '../validation';
import { updateFormData, setListing, updateListing } from '../actions';
import { populateListingFromFormData } from '../helpers';

const mapStateToProps = state => ({
  listing: state.Listing
});

export const ListingFormDescriptionBottomBar = ({ values, submitAndBack, submitAndExit, workflow, isSubmitting, submitText }) => {
  return (
    <div className="button-row row">
      <div className="col-4">
        <label className="float-left" onClick={() => { submitAndBack(values); }}>Back</label>
      </div>
      <div className="col-8">
        <div className="row">
          <div className="col-md-6 col-12">
            {workflow !== "edit" &&
              <label className="float-right" onClick={() => { submitAndExit(values) }}>Save & Finish Later</label>
            }
          </div>
          <div className="col-md-6 col-12">
            {isSubmitting ?
              <button className="btn-primary float-right" disabled={true} onClick={() => { }}>Saving...</button> :
              <button className="btn-primary float-right" type="submit">
                {submitText}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

class ListingFormDescriptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false
    }

    const workflow = this.props.workflow ? this.props.workflow : 'forms';
    this.nextPage = `/${this.props.parent}/listing/${workflow}/amenities`;
    this.prevPage = `/${this.props.parent}/listing/${workflow}/details`;
  }

  saveListing = (values, pathAfterSave) => {
    this.setState({ isSubmitting: true });
    let { dispatch, listing, step, history } = this.props;
    if (values.lastCompleted < step) { values.lastCompleted = step; }
    setTimeout(() => {
      dispatch(updateFormData(values));
      let updatedData = populateListingFromFormData(values);
      if (!updatedData._id) {
        updatedData._id = listing.listingData._id;
      }
      dispatch(setListing(updatedData));
      dispatch(updateListing()).then(() => {
        history.push(pathAfterSave);
      })
    }, 1000);
  }

  onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);
    this.saveListing(values, this.nextPage);
  }

  submitAndBack = (values) => {
    this.saveListing(values, this.prevPage);
  }

  submitAndExit = (values) => {
    this.saveListing(values, `/${this.props.parent}/manage-listings`);
  }

  render() {
    let initialValues = this.props.listing.formData;
    const submitText = this.props.exit ? 'Save' : 'Next';
    return (
      <Formik onSubmit={this.onSubmit} initialValues={initialValues} validationSchema={ListingDescriptionSchema}>
        {({ values, errors, touched }) => (
          <Form>
            <div>
              <div>
                <h5>About the Property</h5>
                <div className="fieldgroup">
                  <Field
                    name="about"
                    component="textarea"
                    rows="5"
                    cols="30"
                    placeholder="Describe your listing..."
                    height="20"
                    className={"form-control " + (touched.about && errors.about ? 'error-input' : '')} />
                  <ErrorMessage name="about" component="div" className="error-message" />
                </div>
              </div>
              <div>
                <h5>Sleeping Arrangements</h5>
                <div>
                  Please describe the sleeping arrangements in your listing, including
                  the bathroom arrangement. For example, "1x King bed - private bathroom".
                </div>
                <div className="fieldgroup">
                  <Field
                    name="sleepingArrangements"
                    component="textarea"
                    rows="4"
                    cols="30"
                    placeholder="- ex. 2x Queen bed - shared bathroom"
                    height="15"
                    className={"form-control " + (touched.sleepingArrangements && errors.sleepingArrangements ? 'error-input' : '')} />
                  <ErrorMessage name="sleepingArrangements" component="div" className="error-message" />
                </div>
              </div>
              <div>
                <h5>Host Rules</h5>
                <div className="fieldgroup row">
                  <Field
                    type="checkbox"
                    name="petsAllowed"
                    className="form-control-sm"
                    checked={values.petsAllowed}
                  />
                  <label className="col-9">Pets Allowed</label>
                </div>
                <div className="fieldgroup row">
                  <Field
                    type="checkbox"
                    name="smokingAllowed"
                    className="form-control-sm"
                    checked={values.smokingAllowed}
                  />
                  <label className="col-9">Smoking Allowed</label>
                </div>
              </div>
            </div>
            <ListingFormDescriptionBottomBar
              isSubmitting={this.state.isSubmitting}
              submitAndBack={this.submitAndBack}
              submitAndExit={this.submitAndExit}
              submitText={submitText}
              values={values}
              workflow={this.props.workflow}
            />
          </Form>
        )}
      </Formik>
    )
  }
}

export default withRouter(connect(mapStateToProps)(ListingFormDescriptions));
